var classes = {"dropdownWrapper":"C-xyM","coachmarkWrapperDefault":"YzMql","coachmarkWrapperHighlight":"HG6Ok","secondaryContent":"a0rri","infoContent":"hYX2-","coachmarkDropdownTarget":"g4Dv4","coachmarkSizeBig":"WPgCt","coachmarkSizeSmall":"p4i2p"};

export { classes as default };
